var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetssonStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9683 7.40846C32.8863 3.19851 27.5699 0.878906 22.0001 0.878906C16.4251 0.878906 11.1087 3.19851 7.02407 7.41113C2.8781 11.6877 0.601158 17.4334 0.779794 23.1765C1.28371 39.451 20.4537 52.1235 21.2723 52.6541L21.9895 53.1207L22.7147 52.6621C23.5305 52.1449 42.714 39.779 43.2205 23.1738C43.3965 17.4334 41.1169 11.6851 36.9683 7.40846Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40991 21.9651C7.40991 30.0106 13.957 36.5526 22.0025 36.5526C30.048 36.5526 36.5899 30.0106 36.5899 21.9651C36.5899 13.9194 30.048 7.37207 22.0025 7.37207C13.957 7.37207 7.40991 13.9194 7.40991 21.9651Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8661 24.5815C28.8661 27.0312 26.964 29.5122 23.3274 29.5122C21.2376 29.5122 19.0248 28.1644 17.7396 26.7987C17.7087 25.1352 17.7087 23.4712 17.7396 21.8077C18.884 20.6275 20.5559 19.3111 23.3721 19.3111C26.0342 19.3111 28.8661 20.6901 28.8661 24.5815ZM23.513 16.8614C20.7883 16.8614 19.2572 17.7286 17.7552 18.8283V12.9543C17.7552 12.4112 17.3082 11.9619 16.7651 11.9619H14.9993V28.645L14.7378 31.5439H16.3627C17.0892 31.5439 17.259 31.0478 17.3529 30.5985L17.5854 29.7134C19.2394 31.0478 20.7257 31.9619 23.7767 31.9619C29.5478 31.9619 31.6377 27.514 31.6377 24.5346C31.622 21.6669 29.9189 16.8614 23.513 16.8614Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetssonStorePin);
export default __webpack_public_path__ + "static/media/BetssonStorePin.2299f5c20751e57791c5ea8eb874d421.svg";
export { ForwardRef as ReactComponent };